import { render } from "./DashCard.vue?vue&type=template&id=3a19a62c&scoped=true"
import script from "./DashCard.vue?vue&type=script&lang=ts"
export * from "./DashCard.vue?vue&type=script&lang=ts"

import "./DashCard.vue?vue&type=style&index=0&id=3a19a62c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3a19a62c"

export default script